import React, { useState } from 'react';
import styles from './index.module.css';
import { Sidebar } from '../../components/shared/side-bar';
import { Home } from "@onro/onboarding";
import { get_accessToken, get_id, get_lang, get_refreshToken, get_username } from '../../helper/UserData/userdate';
import {  Redirect } from "react-router-dom";
import { DispatcherApi } from '../../service/API/dispatcher';
import history from '../../service/history';
import { useDispatch } from 'react-redux';
import { SetSettings } from '../../Redux/actions/actionNames';
import { Helmet } from "react-helmet";

const Dispatcher = new DispatcherApi();


export function GettingStartedLayout(props) {
    const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
    const [readytogo, setReadytogo] = useState(false);
    const dispatch = useDispatch();


    const handleonResponse = async (res) => {
        const data = await Dispatcher.Setting({ userId: get_id(), refreshToken: get_refreshToken() });
        dispatch(SetSettings(data))

        var priority = ["Ondemand", "Pickup", "Delivery", "PickupDelivery"];
        let orderTypes = await data.orderTypes.sort((a, b) => priority.indexOf(a) - priority.indexOf(b))
          history.push(`/${orderTypes[0]}`)
          setReadytogo(orderTypes[0])
          window.location.reload()
    }


       if (readytogo) {
             return <Redirect
                 to={`/${orderTypes[0]}`}
             />
          }

    return <div
        className={styles.App}
    >
                    <Helmet>
        
                        <style type="text/css">{`
                    body .changingCssAnimationxx { 
          
                    z-index: -1;
                     background-color: #ffffff;
                 background: unset;
             -webkit-animation: sdfdsf 1000ms linear infinite;
                  animation: sdfdsf 1000ms forwards ease-in-out;  
                  animation-iteration-count: 1
        
        }
                 `}</style>
        
        
        
        
                    </Helmet>
        <div style={{ height: "100%", width: "100%", flex: "1" ,overflowY:"scroll"}}>
            <Home onResponse={handleonResponse} restUrl={global.config.restServerUrl} userName={get_username()} accessToken={get_accessToken()}
            refreshToken={get_refreshToken()} userId={get_id()} language={get_lang()}
            />
        </div>



    </div>

}


